import cx from 'clsx';
import type { ComponentsContainer } from 'queries/graphql';

import Accordion from 'generic/Accordion';
import Hero from 'generic/Hero';
import ValueProposition from 'generic/ValueProposition';
import Banner from 'generic/Banner';
import BulletList from 'generic/BulletList';
import Comparison from 'generic/Comparison';
import DetailList from 'generic/DetailList';
import FeaturedIn from 'generic/FeaturedIn';
import Guarantee from 'generic/Guarantee';
import HeaderLogo from 'generic/HeaderLogo';
import Testimonial from 'generic/Testimonial';

import MultiVariantBundle from '../MultiVariantBundle';
import FinalCta from '../FinalCta';
import Callout from '../Callout';
import AutoplayVideo from '../AutoplayVideo';
// Container variant
import HeadingImageTextContainer from '../HeadingImageTextContainer';
import LogoBanner from '../LogoBanner';
import PeopleLooking from '../PeopleLooking';
import ReviewStars from '../ReviewStars';
import ColumnImage from '../ColumnImage';
import ImageCarousel from '../ImageCarousel';
import FunnelCart from '../FunnelCart';
import SubscriptionCart from '../SubscriptionCart';
import MultiBundle from '../MultiBundle';
import VideoSection from '../VideoSection';

export default function Container({
  sectionId,
  display,
  flexDirection,
  flexWrap,
  justifyContent,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  paddingBottom,
  paddingLeft,
  paddingRight,
  paddingTop,
  style,
  classList,
  components,
}: ComponentsContainer) {
  const _style = {
    display,
    flexDirection,
    flexWrap,
    justifyContent,
    marginBottom,
    marginLeft,
    marginRight,
    marginTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    paddingTop,
    ...style,
  };

  return (
    <div id={sectionId} style={_style}>
      <div className={cx(classList)}>
        {components.map((component, index) => {
          const {
            callout,
            hero,
            bulletList,
            accordion,
            finalCta,
            autoplayVideo,
            banner,
            comparison,
            detailList,
            featuredIn,
            guarantee,
            headerLogo,
            headingImageText,
            logoBanner,
            peopleLooking,
            reviewStar,
            valueProposition,
            columnImage,
            imageCarousel,
            testimonial,
            container,
            funnelCart,
            subscriptionCart,
            multiBundle,
            multiVariantBundle,
            videoSection,
          } = component;

          if (container) {
            return <Container key={index} {...container} />;
          } else if (hero) {
            return <Hero key={index} {...hero} />;
          } else if (accordion) {
            return <Accordion key={index} {...accordion} />;
          } else if (bulletList) {
            return <BulletList key={index} {...bulletList} />;
          } else if (finalCta) {
            return <FinalCta key={index} {...finalCta} />;
          } else if (callout) {
            return <Callout key={index} {...callout} />;
          } else if (autoplayVideo) {
            return <AutoplayVideo key={index} {...autoplayVideo} />;
          } else if (banner) {
            return <Banner key={index} {...banner} />;
          } else if (comparison) {
            return <Comparison key={index} {...comparison} />;
          } else if (detailList) {
            return <DetailList key={index} {...detailList} />;
          } else if (featuredIn) {
            return <FeaturedIn key={index} {...featuredIn} />;
          } else if (guarantee) {
            return <Guarantee key={index} {...guarantee} />;
          } else if (headerLogo) {
            return <HeaderLogo key={index} {...headerLogo} />;
          } else if (headingImageText) {
            return <HeadingImageTextContainer key={index} {...headingImageText} />;
          } else if (logoBanner) {
            return <LogoBanner key={index} {...logoBanner} />;
          } else if (peopleLooking) {
            return <PeopleLooking key={index} {...peopleLooking} />;
          } else if (reviewStar) {
            return <ReviewStars key={index} {...reviewStar} />;
          } else if (valueProposition) {
            return <ValueProposition key={index} {...valueProposition} />;
          } else if (columnImage) {
            return <ColumnImage key={index} {...columnImage} />;
          } else if (imageCarousel) {
            return <ImageCarousel key={index} {...imageCarousel} />;
          } else if (videoSection) {
            return <VideoSection key={index} {...videoSection} />;
          } else if (testimonial) {
            return <Testimonial key={index} {...testimonial} />;
          } else if (funnelCart) {
            return <FunnelCart key={index} {...funnelCart} />;
          } else if (subscriptionCart) {
            return <SubscriptionCart key={index} {...subscriptionCart} />;
          } else if (multiBundle) {
            return <MultiBundle key={index} {...multiBundle} />;
          } else if (multiVariantBundle) {
            return <MultiVariantBundle key={index} {...multiVariantBundle} />;
          }

          return null; // Return null if no component is found
        })}
      </div>
    </div>
  );
}
